/*
 * @description:
 * @author: cuicui
 * @Date: 2022-11-29 20:26:41
 * @LastEditTime: 2023-01-29 21:46:43
 * @LastEditors: cuicui
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import moment from 'moment'
import '@/assets/style/_global-style.scss'

import instance from "./utils/instance.js";
Vue.prototype.$ajax = instance;
Vue.prototype.moment = moment;
Vue.config.productionTip = false;

//引入clipboard2复制粘贴1
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

//引入swiper
import 'swiper/dist/css/swiper.min.css'
import 'swiper/dist/js/swiper.min.js'
// 引入elementUI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI);

//图片剪裁
import VueCropper from 'vue-cropper'
Vue.use(VueCropper)

//百度地图配置
import BaiduMap from 'vue-baidu-map'

Vue.use(BaiduMap, {
    ak: 'SKr0401y7kGMDsmjNBbB9TexuHt2KusY'
});

import directives from '@/utils/directives'
Vue.use(directives);

const pointDoms = []; // 使用这个指令的所有DOM对象
Vue.directive('points', {
    inserted(el, binding) {
        pointDoms.push(el); // 存储使用这个指令的DOM
        el.addEventListener('click', () => {
            // 禁用所有使用这个指令的DOM结构点击事件
            pointDoms.forEach(pointItem => {
                pointItem.style.pointerEvents = 'none';
            });
            setTimeout(() => {
                // 启动所有使用这个指令的DOM结构点击事件
                pointDoms.forEach(pointItem => {
                    pointItem.style.pointerEvents = 'auto';
                });
            }, binding.value || 350);
        });
    }
});

router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title
    }
    next()
});

new Vue({
    router,
    store,
    el: '#app',
    render: h => h(App)
}).$mount('#app');
